import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
  base: {
    fontWeight: 'bold',
  },
  variants: {
    variant: {
      sub: {
        color: 'gray.400',
      },
    },
    size: {
      '4xl': {
        fontSize: '4xl',
      },
      '2xl': {
        fontSize: '2xl',
      },
      xl: {
        fontSize: 'xl',
        lineHeight: '24px',
      },
      md: {
        fontSize: 'md',
      },
    },
  },
  defaultVariants: {
    size: '4xl',
  },
});
